import { useState } from "react";

export interface CaseInitiationFormData {
  caseName: string;
  mrn: string;
  caseDate: string;
  firstName: string;
  lastName: string;
  prescriberName: string;
  drugName: string;
  key: string;
}

export const useCaseInitiationForm = () => {
  const [formData, setFormData] = useState<CaseInitiationFormData>({
    caseName: "",
    mrn: "",
    caseDate: "",
    firstName: "",
    lastName: "",
    prescriberName: "",
    drugName: "",
    key: "",
  });

  const handleFieldChange = (
    field: keyof CaseInitiationFormData,
    value: string,
  ) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const isFormValid = () => {
    return (
      formData.mrn.trim() !== "" &&
      formData.caseDate.trim() !== "" &&
      formData.firstName.trim() !== "" &&
      formData.lastName.trim() !== "" &&
      formData.prescriberName.trim() !== "" &&
      formData.drugName.trim() !== "" &&
      formData.key.trim() !== ""
    );
  };

  return {
    formData,
    handleFieldChange,
    isFormValid,
  };
};
